export default "__VITE_ASSET__5b9a0c50__"